import { useState, useEffect, useRef } from 'react';
import { useApp } from '@/context/AppContext';
import { auth } from '@/data/supabase';

export default function UserMenu({ initials = 'MR', align = 'right' }) {
  const { cloudMode, userEmail } = useApp();
  const [open, setOpen] = useState(false);
  const [theme, setTheme] = useState(
    () => document.documentElement.getAttribute('data-theme') || 'light'
  );
  const wrapRef = useRef(null);

  // Close on outside click
  useEffect(() => {
    if (!open) return;
    const handle = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handle);
    return () => document.removeEventListener('mousedown', handle);
  }, [open]);

  const toggleTheme = () => {
    const next = theme === 'dark' ? 'light' : 'dark';
    setTheme(next);
    document.documentElement.setAttribute('data-theme', next);
    try { localStorage.setItem('painterops_theme', next); } catch {}
  };

  const handleSignOut = async () => {
    try {
      await auth.signOut();
    } catch {}
    // Clear local-mode flag too, just in case
    try { sessionStorage.removeItem('wo_local_mode'); } catch {}
    window.location.reload();
  };

  const handleExitLocal = () => {
    try { sessionStorage.removeItem('wo_local_mode'); } catch {}
    window.location.reload();
  };

  return (
    <div className="user-menu-wrap" ref={wrapRef}>
      <div
        className="av"
        onClick={() => setOpen(o => !o)}
        title={userEmail || 'Account'}
      >
        {initials}
      </div>

      {open && (
        <div className="user-menu" style={align === 'left' ? { right: 'auto', left: 0 } : undefined}>
          <div className="user-menu-info">
            <div className="user-menu-email">
              {userEmail || (cloudMode ? 'Signed in' : 'Local Demo')}
            </div>
            <div className="user-menu-mode">
              {cloudMode ? 'Cloud Account' : 'Local Mode'}
            </div>
          </div>

          <button className="user-menu-item" onClick={toggleTheme}>
            Switch to {theme === 'dark' ? 'Light' : 'Dark'} Mode
          </button>

          {cloudMode ? (
            <button className="user-menu-item danger" onClick={handleSignOut}>
              Sign Out
            </button>
          ) : (
            <button className="user-menu-item" onClick={handleExitLocal}>
              Exit Local Mode
            </button>
          )}
        </div>
      )}
    </div>
  );
}
